export const NS_LIBS_CMDB_INSTANCES = "libs-cmdb-instances";

export enum K {
  VALIDATE_MESSAGE_REQUIRED = "VALIDATE_MESSAGE_REQUIRED",
  DYNAMIC_FILTER = "DYNAMIC_FILTER",
  TIP = "TIP",
  DELETE = "DELETE",
  INVALID_OR_FORBIDDEN_IPS = "INVALID_OR_FORBIDDEN_IPS",
  INVALID = "INVALID",
  SELECT_FROM_CMDB = "SELECT_FROM_CMDB",
  IP_PLACEHOLDER = "IP_PLACEHOLDER",
  CLICK_TO_SELECT = "CLICK_TO_SELECT",
  MATCHING_REGULAR = "MATCHING_REGULAR",
  ADD = "ADD",
  ENTER_MULTIPLE_STRING_WITH_ENTER_KEY_AS_THE_SEPARATOR = "ENTER_MULTIPLE_STRING_WITH_ENTER_KEY_AS_THE_SEPARATOR",
  UNIQUE_NO_REPEAT = "UNIQUE_NO_REPEAT",
  TYPE_NO_SUPPORT_EDIT = "TYPE_NO_SUPPORT_EDIT",
  TEMPORARILY_NOT_CHOOSE = "TEMPORARILY_NOT_CHOOSE",
  ENUM_ERROR_TIP = "ENUM_ERROR_TIP",
  STRUCT_ERROR_TIP = "STRUCT_ERROR_TIP",
  LINK = "LINK",
  LINK_PLACEHOLDER = "LINK_PLACEHOLDER",
  TITLE = "TITLE",
  TITLE_PLACEHOLDER = "TITLE_PLACEHOLDER",
  CLICK_TO_FILTER = "CLICK_TO_FILTER",
  CLICK_TO_CANCEL_FILTER = "CLICK_TO_CANCEL_FILTER",
  CLICK_TO_HIDDEN = "CLICK_TO_HIDDEN",
  CLICK_TO_SHOW = "CLICK_TO_SHOW",
  RELATED_TO_ME = "RELATED_TO_ME",
  DISPLAY_OMITTED_INFORMATION = "DISPLAY_OMITTED_INFORMATION",
  CLEAR = "CLEAR",
  NORMAL_HOST = "NORMAL_HOST",
  CURRENT_FILTER_REQUIREMENTS = "CURRENT_FILTER_REQUIREMENTS",
  ADVANCED_SEARCH = "ADVANCED_SEARCH",
  CHOSEN_OPTIONS = "CHOSEN_OPTIONS",
  FUZZY_SEARCH = "FUZZY_SEARCH",
  BASIC_INFORMATION = "BASIC_INFORMATION",
  MORE = "MORE",
  DEFAULT_ATTRIBUTE = "DEFAULT_ATTRIBUTE",
  CANCEL = "CANCEL",
  CLOSE = "CLOSE",
  DISPLAY_SETTINGS = "DISPLAY_SETTINGS",
  FIELD_SETTINGS = "FIELD_SETTINGS",
  SEARCH_BY_FIELD_NAME = "SEARCH_BY_FIELD_NAME",
  SELECT_ALL = "SELECT_ALL",
  RESTORE_DEFAULT = "RESTORE_DEFAULT",
  SET_DEFAULT_DISPLAY_SUCCESS = "SET_DEFAULT_DISPLAY_SUCCESS",
  DEFAULT_DISPLAY = "DEFAULT_DISPLAY",
  CONFIRM = "CONFIRM",
  SORT_SETTINGS = "SORT_SETTINGS",
  ONLY_ONE_INSTANCE_TO_ALLOWED = "ONLY_ONE_INSTANCE_TO_ALLOWED",
  OPERATOR_CONTAIN_DEFINE = "OPERATOR_CONTAIN_DEFINE",
  OPERATOR_NOT_CONTAIN_DEFINE = "OPERATOR_NOT_CONTAIN_DEFINE",
  OPERATOR_EQUAL_DEFINE = "OPERATOR_EQUAL_DEFINE",
  OPERATOR_NOT_EQUAL_DEFINE = "OPERATOR_NOT_EQUAL_DEFINE",
  OPERATOR_IS_EMPTY_DEFINE = "OPERATOR_IS_EMPTY_DEFINE",
  OPERATOR_IS_NOT_EMPTY_DEFINE = "OPERATOR_IS_NOT_EMPTY_DEFINE",
  OPERATOR_BETWEEN_DEFINE_TEXT = "OPERATOR_BETWEEN_DEFINE_TEXT",
  OPERATOR_BETWEEN_DEFINE_TEXT_TIME = "OPERATOR_BETWEEN_DEFINE_TEXT_TIME",
  OPERATOR_BETWEEN_DEFINE_TEXT_INT = "OPERATOR_BETWEEN_DEFINE_TEXT_INT",
  OPERATOR_BETWEEN_DEFINE_TEXT_THE = "OPERATOR_BETWEEN_DEFINE_TEXT_THE",
  SEARCH = "SEARCH",
  RESET = "RESET",
  CREATOR = "CREATOR",
  CREATE_TIME = "CREATE_TIME",
  MODIFIER = "MODIFIER",
  MODIFY_TIME = "MODIFY_TIME",
  DEV = "DEV",
  TEST = "TEST",
  PROD = "PROD",
  PRE_RELEASE = "PRE_RELEASE",
  VIEW = "VIEW",
  ITEM_ADD_IN_BATCHES = "ITEM_ADD_IN_BATCHES",
  SAVE = "SAVE",
  SAVE_AND_CONTINUE = "SAVE_AND_CONTINUE",
  MODIFICATION = "MODIFICATION",
  NOT_MEET_REGEX = "NOT_MEET_REGEX",
  NOT_MEET_REGEX_DETAIL = "NOT_MEET_REGEX_DETAIL",
  NOT_MEET_JSON = "NOT_MEET_JSON",
  NOT_MEET_XML = "NOT_MEET_XML",
  CREATE_ANOTHER = "CREATE_ANOTHER",
  DELETE_STRUCT_CONFIRM_MSG = "DELETE_STRUCT_CONFIRM_MSG",
  DELETE_INSTANCE_CONFIRM_MSG = "DELETE_INSTANCE_CONFIRM_MSG",
  OPERATION = "OPERATION",
  VIEW_ALL_SELECTED_INSTANCES = "VIEW_ALL_SELECTED_INSTANCES",
  CHOOSE_INSTANCE = "CHOOSE_INSTANCE",
  CHOOSE_INSTANCE_NAME = "CHOOSE_INSTANCE_NAME",
  VIEW_ALL_DATA = "VIEW_ALL_DATA",
  FILTER_FROM_CMDB = "FILTER_FROM_CMDB",
  PAGINATION_TOTAL_TEXT = "PAGINATION_TOTAL_TEXT",
  PAGINATION_TOTAL_UNIT = "PAGINATION_TOTAL_UNIT",
  JUMP_TO = "JUMP_TO",
  INSTANCE_DETAIL = "INSTANCE_DETAIL",
  COPY = "COPY",
  COPY_SUCCESS = "COPY_SUCCESS",
  // FILTER_FROM_CMDB = "FILTER_FROM_CMDB",
  USERS = "USERS",
  USER_GROUPS = "USER_GROUPS",
  USERS_OR_USER_GROUPS = "USERS_OR_USER_GROUPS",
  SWITCH = "SWITCH",
  USERS_RESULT_LABEL = "USERS_RESULT_LABEL",
  NO_DATA = "NO_DATA",
  USER_GROUPS_RESULT_LABEL = "USER_GROUPS_RESULT_LABEL",
  PERMISSION_WHITELIST = "PERMISSION_WHITELIST",
  FILTER_FROM_CMDB_TYPE = "FILTER_FROM_CMDB_TYPE",
  ALL_CLUSTER = "ALL_CLUSTER",
  FREE_SELECTION = "FREE_SELECTION",
  APP_SELECTION = "APP_SELECTION",
  ATTRIBUTE_NAME_REQUIRED = "ATTRIBUTE_NAME_REQUIRED",
  INSTANCE_SOURCE = "INSTANCE_SOURCE",
  INSTANCE_SOURCE_TOOLTIP = "INSTANCE_SOURCE_TOOLTIP",
  INSTANCE_SOURCE_TAG_TEXT = "INSTANCE_SOURCE_TAG_TEXT",
  COPY_SELECTED_IP = "COPY_SELECTED_IP",
  SELECT_COPY_DATA = "SELECT_COPY_DATA",
  ADVANCE_SEARCH_SINGLE_INPUT_PLACEHOLDER = "ADVANCE_SEARCH_SINGLE_INPUT_PLACEHOLDER",
  NUMBER_INPUT_PLACEHOLDER_TPL = "NUMBER_INPUT_PLACEHOLDER_TPL",
  INTEGER_INPUT_PLACEHOLDER_TPL = "INTEGER_INPUT_PLACEHOLDER_TPL",
  FLOAT_INPUT_PLACEHOLDER_TPL = "FLOAT_INPUT_PLACEHOLDER_TPL",
  INPUT_PLACEHOLDER_TPL = "INPUT_PLACEHOLDER_TPL",
  SELECT_PLACEHOLDER_TPL = "SELECT_PLACEHOLDER_TPL",
  FIX_HEADER = "FIX_HEADER",
  CANCEL_FIX_HEADER = "CANCEL_FIX_HEADER",
  VIEW_SPECIFIC_INSTANCES = "VIEW_SPECIFIC_INSTANCES",
  VIEW_MORE = "VIEW_MORE",
  CREATE_AND_BIND = "CREATE_AND_BIND",
  PERMISSION_DENIED = "PERMISSION_DENIED",
  CLICK_TO_FILTER_INSTANCE_SOURCE = "CLICK_TO_FILTER_INSTANCE_SOURCE",
  SEARCH_MODEL = "SEARCH_MODEL",
  UPLOAD_SIZE_LARGE_TEXT = "UPLOAD_SIZE_LARGE_TEXT",
  UPLOAD = "UPLOAD",
  BACKGROUND_SEARCH = "BACKGROUND_SEARCH",
  BACK = "BACK",
  RELATION_INSTANCE_TOOLTIP = "RELATION_INSTANCE_TOOLTIP",
  NAME = "NAME",
  ID = "ID",
  SORT = "SORT",
  COMMA = "COMMA",
  MORE_RESULTS_TIPS = "MORE_RESULTS_TIPS",
  OTHERS = "OTHERS",
}

export type Locale = { [key in K]: string };
